import { api } from './client'

export interface ManualInfo {
  key: string
  title: string
}

export const manualsApi = {
  /** Список руководств, доступных роли текущего пользователя. */
  list: () => api.get<ManualInfo[]>('/manuals'),

  /** HTML руководства (грузится с JWT — <iframe src> сюда не подходит). */
  get: (key: string) => api.get<string>(`/manuals/${key}`, { responseType: 'text' }),
}
